import axios from 'axios'
import { Interseptor } from './Interseptor'
import { clearToken, getToken, setToken } from './tokenStore'

export let baseURL = 'https://customerjourney.flyhifinance.com'
//export let baseURL = 'https://uat.customerjourney.flyhifinance.com'
//export let baseURL = 'http://localhost:8080'

const instanceUrl = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  transformRequest: [
    function (data, headers) {
      const jwt = getToken()
      if (jwt) {
        headers.Authorization = 'Bearer ' + jwt
      }
      headers['X-Trace-Id'] = getOrCreateTraceId()
      return JSON.stringify(data)
    }
  ],
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache'
  }
})

// Silent-refresh state — prevents multiple concurrent refresh calls
let isRefreshing = false
let failedQueue = []

function processQueue(error, token = null) {
  failedQueue.forEach(p => (error ? p.reject(error) : p.resolve(token)))
  failedQueue = []
}

function setupInterceptors() {
  instanceUrl.interceptors.request.use(request => Interseptor.requestHandler(request))
  instanceUrl.interceptors.response.use(
    response => Interseptor.successHandler(response),
    async error => {
      const originalRequest = error.config

      // Attempt silent refresh on 401, but not for the refresh call itself
      if (
        error.response?.status === 401 &&
        !originalRequest._retry &&
        !originalRequest.url?.includes('auth/refresh')
      ) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject })
          })
            .then(token => {
              originalRequest.headers.Authorization = 'Bearer ' + token
              return instanceUrl(originalRequest)
            })
            .catch(err => Promise.reject(err))
        }

        originalRequest._retry = true
        isRefreshing = true

        try {
          const res = await axios.post(
            baseURL + '/api/client/auth/refresh',
            null,
            { withCredentials: true }
          )
          const newToken = res.data?.jwt
          if (!newToken) throw new Error('No token in refresh response')

          setToken(newToken)
          processQueue(null, newToken)
          originalRequest.headers.Authorization = 'Bearer ' + newToken
          return instanceUrl(originalRequest)
        } catch (refreshError) {
          processQueue(refreshError, null)
          clearToken()
          window.location.href = '/welcome'
          return Promise.reject(refreshError)
        } finally {
          isRefreshing = false
        }
      }

      return Interseptor.errorHandler(error)
    }
  )
}

let interceptorsInitialised = false

export const httpservice = () => {
  if (!interceptorsInitialised) {
    setupInterceptors()
    interceptorsInitialised = true
  }
  return instanceUrl
}

function getOrCreateTraceId() {
  let traceId = localStorage.getItem('traceId')
  if (!traceId) {
    traceId = 'trace-' + Math.random().toString(36).substr(2, 9)
    localStorage.setItem('traceId', traceId)
  }
  return traceId
}
